// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bsbuuw1{width:200px}
._4t3i11ux{height:140px}
._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/dist/esm/ui/common/error-state/provider-auth-required-svg.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW;AACtB,WAAW,YAAY;AACvB,WAAW,qCAAqC","sourcesContent":["._1bsbuuw1{width:200px}\n._4t3i11ux{height:140px}\n._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
